import '@updater-components/icon';
import '@updater-components/radio-group';
import template from './credit-card.html';
import { actions, selectors } from '../../../state';
import {
  STRIPE_INVALID_ADDRESS,
  CC_INVALID_ADDRESS,
  MONTHS_SHORT,
} from '../../../constants';
import './credit-card.global.css';

// Stripe expects the month indices to be 1-12. Also, make it easier/clearer to
// display for ng-options
const MONTHS_LIST = MONTHS_SHORT.map((label, index) => ({
  label,
  index: index + 1,
}));

const ADDRESS_VALUES = {
  FROM: 'from',
  TO: 'to',
};

class VerifyCreditCardController {
  constructor(updStore, StripeService) {
    'ngInject';
    Object.assign(this, {
      updStore,
      StripeService,
      address: ADDRESS_VALUES.FROM,
      fromAddressValue: ADDRESS_VALUES.FROM,
      toAddressValue: ADDRESS_VALUES.TO,
      months: MONTHS_LIST,
      card: {
        // Select Jan as default month
        exp_month: 1,
      },
    });
  }

  $onInit() {
    this.disconnect = this.updStore.connect(mapStateToThis)(this);
    this.setCardInfo();
  }

  $onDestroy() {
    this.disconnect();
  }

  onAddressChange(e) {
    this.address = e.target.value;
    this.setCardInfo();
  }

  setCardInfo() {
    this.card = {
      ...this.card,
      ...mapAddressToStripe(this.addresses[this.address]),
    };
  }

  _verifyMove({ token, verify_address }) {
    const { dispatch } = this.updStore;

    const success = () => {
      dispatch(actions.router.stateGo(this.origin, { verified: true }));
      dispatch(actions.analytics.track('Verified By Credit Card'));
    };

    const error = response => {
      if (
        [STRIPE_INVALID_ADDRESS, CC_INVALID_ADDRESS].includes(
          response.payload.code
        )
      ) {
        dispatch(
          actions.message.error(
            'Your billing address does not match your move address.'
          )
        );
      } else {
        dispatch(
          actions.message.error('Something went wrong. Please try again later.')
        );
      }
      dispatch(
        actions.analytics.track('Tried To Verify By Credit Card', {
          Errors: response.payload.errors,
        })
      );
    };

    dispatch(
      actions.move.verification(this.moveId, {
        kind: 'cc',
        verify_address,
        token,
      })
    ).then(success, error);
  }

  submit(card) {
    const { dispatch } = this.updStore;

    const success = response => {
      this._verifyMove({
        token: response.id,
        verify_address: this.address,
      });
    };

    const error = response => {
      const { message } = response;
      dispatch(actions.message.error(message));
      dispatch(
        actions.analytics.track('Tried Creating Stripe Token', {
          Error: message,
        })
      );
    };

    this.StripeService.card({
      ...card,
      name: this.fullName,
    }).then(success, error);
  }
}

export const VerifyCreditCardComponent = {
  template,
  controller: VerifyCreditCardController,
  bindings: {
    origin: '<',
  },
};

function mapStateToThis(state) {
  const move = selectors.current.move(state);
  const user = selectors.current.user(state);

  return {
    moveId: move.id(state),
    fullName: `${user.firstName(state)} ${user.lastName(state)}`,
    submitting: selectors.pending.match(actions.move.isCreate, state),
    addresses: {
      [ADDRESS_VALUES.FROM]: move.fromAddress(state),
      [ADDRESS_VALUES.TO]: move.toAddress(state),
    },
  };
}

function mapAddressToStripe(address) {
  return {
    address_line1: [address.street, address.apt].join(' ').trim(),
    address_city: address.city,
    address_state: address.state,
    address_zip: address.zip,
  };
}
